// extracted by mini-css-extract-plugin
module.exports = {"Text":"tmo1ZGn8PBnvU7CKfq2vA"};